<template>
  <div>
    <b-table
      id="facial-device-employees-table"
      ref="facial-device-employees-table"
      borderless
      responsive="md"
      :items="getItems"
      :fields="fields"
      :busy="isBusy"
      show-empty
      hover
      table-class="table-head-custom table-vertical-center table-head-bg"
      @row-clicked="handleCheckBox"
    >
      <!-- begin: When table's empty -->
      <template #empty="">
        <AppEmptyList
          text-top="No Employees Added"
          text-bottom="To add employees to this device, go to List"
        ></AppEmptyList>
      </template>
      <!-- end: When table's empty -->

      <!-- begin: t-head -->
      <template v-slot:head(index)="data">
        <span class="text-dark-75">{{ data.label.toUpperCase() }}</span>
      </template>
      <!-- end: t-head -->

      <template v-slot:cell(index)="data">
        <span class="font-weight-bolder">{{ data.index + 1 }}</span>
      </template>

      <template v-slot:cell(selected)="data">
        <div class="d-flex mt-1 mb-2 justify-content-center">
          <b-form-checkbox
            size="lg"
            class="h6"
            v-model="data.item.selected"
          ></b-form-checkbox>
        </div>
      </template>

      <template v-slot:cell(name)="data">
        <CommonEmployeeSummary :item="data.item"></CommonEmployeeSummary>
      </template>

      <template #table-busy>
        <AppLoader />
      </template>
    </b-table>

    <div class="d-flex justify-content-end" v-if="items.length">
      <b-pagination
        pills
        @change="change"
        v-model="pagination.current_page"
        :total-rows="pagination.total"
        :per-page="pagination.per_page"
        aria-controls="facial-device-table"
      ></b-pagination>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import AppLoader from "@/modules/core/components/loaders/AppLoader";
import AppEmptyList from "@/modules/core/components/empty/AppEmptyList";
import CommonEmployeeSummary from "@/modules/core/components/company/CommonEmployeeSummary";

export default {
  name: "FacialDeviceEmployeeTable",
  components: { CommonEmployeeSummary, AppEmptyList, AppLoader },
  props: {
    deviceId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      isBusy: false,
      fields: [
        { key: "index", label: "#", class: "text-center" },
        { key: "selected", label: "Select", class: "text-center" },
        { key: "name", label: this.$t("EMPLOYEESGENERAL.MESSAGE.FIRSTNAME") },
      ],

      selected: {},
    };
  },
  mounted() {
    this.$store.dispatch("emptyFacialDeviceEmployees", this.deviceId);
  },
  methods: {
    getItems() {
      return this.$store
        .dispatch("getFacialEmployeeList", this.deviceId)
        .then((value) => {
          console.log(value.data.data);
          return value.data.data;
        })
        .catch(() => []);
    },

    handleCheckBox(row) {
      console.log(row);
      const index = this.items.findIndex((e) => e.id === row.id);
      this.items[index].selected = !this.items[index].selected;
    },

    change(page) {
      console.log("Reload Table!", page);
      this.$store.commit("setFacialEmployeeListCurrentPage", page);
      this.$refs["facial-device-employees-table"].refresh();
    },
  },

  computed: {
    ...mapState({
      items: (state) => state.DeviceModule.FacialStore.FacialEmployeeList.items,
      pagination: (state) =>
        state.DeviceModule.FacialStore.FacialEmployeeList.pagination,
    }),
    ...mapGetters({
      pagination: "getFacialEmployeeListPagination",
      after: "getAfterEmployeesSelected",
    }),
  },

  watch: {
    after(newValue) {
      console.log("Selected employees changes!");
      if (newValue !== null) {
        this.$refs["facial-device-employees-table"].refresh();
      }
    },
  },
};
</script>

<style scoped></style>
